<div class="bandel-search-container">
    <div class="bandel-search-header">
        <div>
            Zooma till bandel
            <span (click)="openInfo()" style="margin-left: 0.1rem; cursor: pointer; fill: #1e5c88">
                <app-svg-icon [svgIcon]="circleInfoIcon"></app-svg-icon>
            </span>
        </div>

        <button type="button" aria-label="Stäng" class="btn btn-link" (click)="close()">
            <svg
                _ngcontent-qoi-c18=""
                _ngcontent-app-c19=""
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="bi bi-x-lg"
            >
                <path
                    _ngcontent-qoi-c18=""
                    _ngcontent-app-c19=""
                    d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                    fill-rule=""
                    class="ng-star-inserted"
                ></path>
            </svg>
        </button>
    </div>

    <div class="bandel-search-body">
        <trv-form [validationErrors]="validationErrorMap">
            <trv-form-field label="Till:*" [labelGridColumns]="2" [control]="input1">
                <input type="text" class="form-control" placeholder="Bandelsnr kmtal+meter" [formControl]="input1" />
            </trv-form-field>
            <trv-form-field label="Från:" [labelGridColumns]="2" [control]="input2">
                <input type="text" class="form-control" placeholder="Bandelsnr kmtal+meter" [formControl]="input2" />
            </trv-form-field>
        </trv-form>
        <button class="btn btn-primary" (click)="zoomTo()">Zooma till</button>
    </div>
</div>
